function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b8ozryraja"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M0 0h16v16H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b8ozryraja)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.042 9.921a2.326 2.326 0 0 0 2.275 2.441 2.059 2.059 0 0 0 1.592-.693h.171a3.23 3.23 0 0 1-2.3 2.039.842.842 0 0 0-.357.171.333.333 0 0 0-.126.281.392.392 0 0 0 .427.387 1.779 1.779 0 0 0 .593-.116 4.442 4.442 0 0 0 1.793-1.124 4 4 0 0 0 1.1-2.807 2.754 2.754 0 0 0-2.687-3.06 2.424 2.424 0 0 0-2.481 2.481zm6.208 0a2.326 2.326 0 0 0 2.275 2.441 2.074 2.074 0 0 0 1.592-.693h.166a3.221 3.221 0 0 1-2.3 2.039.817.817 0 0 0-.352.171.337.337 0 0 0-.131.281.4.4 0 0 0 .437.387 1.75 1.75 0 0 0 .583-.116 4.442 4.442 0 0 0 1.788-1.125 3.981 3.981 0 0 0 1.1-2.807 2.754 2.754 0 0 0-2.677-3.059 2.421 2.421 0 0 0-2.481 2.481z",
    transform: "translate(-1.732 -3.189)",
    style: {
      fill: "currentColor"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.43c828b0.svg";
export { ForwardRef as ReactComponent };